import { colors } from "./colors";

export const palette = {
  primary: {
    dark: colors.primary.dark,
    main: colors.primary.main,
    light: colors.primary.light,
    contrastText: colors.primary.contrastText,
  },
  secondary: {
    light: colors.secondary.light,
    dark: colors.secondary.dark,
    main: colors.secondary.main,
    contrastText: colors.secondary.contrastText,
  },

  warning: {
    main: colors.warning.main,
    contrastText: colors.warning.contrastText,
    light: colors.warning.light,
    dark: colors.warning.dark,
  },

  error: {
    main: colors.error.main,
    contrastText: colors.error.contrastText,
    dark: colors.error.dark,
    light: colors.error.light,
  },

  success: {
    main: colors.success.main,
    light: colors.success.light,
    dark: colors.success.dark,
    contrastText: colors.success.contrastText,
  },

  info: {
    dark: colors.info.dark,
    light: colors.info.light,
    main: colors.info.main,
    contrastText: colors.info.contrastText,
  },

  disabled: {
    light: colors.disabled.light,
    main: colors.disabled.main,
    dark: colors.disabled.dark,
    contrastText: colors.disabled.contrastText,
  },
  transparent: {
    main: colors.transparent.main,
  },

  chipSuccess: {
    light: colors.chipSuccess.light,
    dark: colors.chipSuccess.dark,
  },

  chipInfo: {
    light: colors.chipInfo.light,
    dark: colors.chipInfo.dark,
  },

  chipWarning:{
    dark: colors.chipWarning.dark,
    light: colors.chipWarning.light,
  },

  chipOnHold:{
  light: colors.chipOnHold.light,
  },

  machineNode:{
     main: colors.machineNode.main,
  },

  disabledColor:{
    light: colors.disabledColor.light,
    dark: colors.disabledColor.dark,
    contrastText: colors.disabledColor.contrastText,
  },
};
